// Event handler for keydown to prevent up and down arrow actions
export const handleKeyDownForNumber = (event) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
    }
};